import React, { useState } from 'react';
import CourseTree from '../models/CourseTree'

const CourseTreeContext = React.createContext([{}, () => {}, () => {}, () => {}]);

const CourseTreeProvider = (props) => {
  const [open, setOpen] = useState({})
  const [courseTree, setCourseTree] = useState(CourseTree(props.item))

  const isOpen = (id) => open[id]
  const toggleOpen = (id) => {
    const newValue = {}
    newValue[id] = !isOpen(id)
    setOpen(Object.assign({}, open, newValue))
  }

  const updateCourseTree = (courseTree) => {
    setCourseTree(CourseTree(courseTree.props))
  }

  return (
    <CourseTreeContext.Provider value={[courseTree, updateCourseTree, isOpen, toggleOpen]}>
      {props.children}
    </CourseTreeContext.Provider>
  );
};

export { CourseTreeContext, CourseTreeProvider}
